// export { MatDialogConfigLocale } from './mat-dialog-config-locale';
export { MatPaginatorIntlLocale } from './mat-paginator-intl-locale';
